import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
// Lazy load below-fold sections — only load when React renders them
const EducationSection = lazy(() => import('../components/EducationSection').then(m => ({
  default: m.EducationSection
})));
const PainSection = lazy(() => import('../components/PainSection').then(m => ({
  default: m.PainSection
})));
const CostSection = lazy(() => import('../components/CostSection').then(m => ({
  default: m.CostSection
})));
const DreamSection = lazy(() => import('../components/DreamSection').then(m => ({
  default: m.DreamSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ProductDisplaySection = lazy(() => import('../components/ProductDisplaySection').then(m => ({
  default: m.ProductDisplaySection
})));
const ProductStack = lazy(() => import('../components/ProductStack').then(m => ({
  default: m.ProductStack
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const UrgencySection = lazy(() => import('../components/UrgencySection').then(m => ({
  default: m.UrgencySection
})));
const CloseSection = lazy(() => import('../components/CloseSection').then(m => ({
  default: m.CloseSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const PurchaseNotification = lazy(() => import('../components/PurchaseNotification').then(m => ({
  default: m.PurchaseNotification
})));
// Minimal loading placeholder — invisible, no layout shift
function SectionFallback() {
  return <div style={{
    minHeight: '200px'
  }} data-id="element-1058" />;
}
export function LandingPage() {
  useEffect(() => {
    document.title = 'LPM™ System - Landing Pages e IA';
    // Meta Pixel — deferred: load after page is interactive
    const loadPixel = () => {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '3188173048187250');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
      const noscript = document.createElement('noscript');
      noscript.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=3188173048187250&ev=PageView&noscript=1" />';
      document.body.appendChild(noscript);
    };
    // Defer pixel load: use requestIdleCallback or fallback to setTimeout
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 3000
      });
    } else {
      setTimeout(loadPixel, 2000);
    }
  }, []);
  return <main className="w-full min-h-screen" style={{
    backgroundColor: '#0f172a'
  }} data-id="element-1059">
      {/* Top Offer Bar */}
      <div className="w-full py-3 px-4 text-center sticky top-0 z-40" style={{
      backgroundColor: '#dc2626'
    }} data-id="element-1060">
        <p className="text-sm md:text-base font-bold" style={{
        color: 'white'
      }} data-id="element-1061">
          OFERTA LIMITADA — Solo 300 cupos a $49.999. Después sube a $99.999.
          ¡No te lo pierdas!
        </p>
      </div>

      {/* Above-fold: load immediately */}
      <HeroSection data-id="element-1062" />
      <HookSection data-id="element-1063" />

      {/* Below-fold: lazy loaded */}
      <Suspense fallback={<SectionFallback data-id="element-1065" />} data-id="element-1064">
        <EducationSection data-id="element-1066" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1068" />} data-id="element-1067">
        <PainSection data-id="element-1069" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1071" />} data-id="element-1070">
        <CostSection data-id="element-1072" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1074" />} data-id="element-1073">
        <DreamSection data-id="element-1075" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1077" />} data-id="element-1076">
        <TestimonialsSection data-id="element-1078" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1080" />} data-id="element-1079">
        <ProductDisplaySection data-id="element-1081" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1083" />} data-id="element-1082">
        <ProductStack data-id="element-1084" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1086" />} data-id="element-1085">
        <GuaranteeSection data-id="element-1087" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1089" />} data-id="element-1088">
        <UrgencySection data-id="element-1090" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1092" />} data-id="element-1091">
        <CloseSection data-id="element-1093" />
      </Suspense>
      <Suspense fallback={<SectionFallback data-id="element-1095" />} data-id="element-1094">
        <FAQSection data-id="element-1096" />
      </Suspense>

      <Suspense fallback={null} data-id="element-1097">
        <PurchaseNotification data-id="element-1098" />
      </Suspense>

      {/* Footer */}
      <footer className="w-full py-8 px-4 border-t text-center" style={{
      backgroundColor: '#0f172a',
      borderColor: '#334155'
    }} data-id="element-1099">
        <p className="text-sm font-mono" style={{
        color: '#64748b'
      }} data-id="element-1100">
          © 2026 LPM™ System — Todos los derechos reservados.
        </p>
        <p className="text-xs mt-2" style={{
        color: '#475569'
      }} data-id="element-1101">
          Los resultados mencionados son proyecciones basadas en ejecución
          consistente. Los resultados individuales varían según el esfuerzo,
          experiencia y constancia.
        </p>
      </footer>
    </main>;
}